import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> { }

const BigPlayIcon: React.FC<Props> = (props) => {
  return (
    <svg {...props} width="21" height="25" viewBox="0 0 21 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.87689 0.388625L19.3722 10.0735C20.9611 11.066 20.9611 13.3784 19.3698 14.3684L3.87689 24.0533C2.19022 25.1093 0 23.8944 0 21.9046V2.53729C0 0.547514 2.19022 -0.66493 3.87689 0.388625Z" fill="#008AF6" />
    </svg>
  );
};

export default BigPlayIcon;
